import { render, staticRenderFns } from "./ChoiceSelect.vue?vue&type=template&id=5d3dd726&"
import script from "./ChoiceSelect.vue?vue&type=script&lang=js&"
export * from "./ChoiceSelect.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceSelect.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default,BaseChoice: require('/opt/build/repo/storefront/components/atoms/Swatch/BaseChoice.vue').default})
